import { COMMON_TWO_LEVEL_DOMAINS } from './domain_tld';

export function getRootDomain(hostname: string): string {
  const parts = hostname.split('.');
  if (parts.length < 2 || parts.length > 4) return hostname;

  if (parts[0] == 'www') return parts.slice(1).join('.');

  // eg: example.myshopify.com -> example.myshopify.com
  //     sub1.example.myshopify.com -> example.myshopify.com
  const lastTwoTldIndex = -2;
  const lastTwoTld = parts.slice(lastTwoTldIndex).join('.');

  if (COMMON_TWO_LEVEL_DOMAINS.includes(lastTwoTld)) {
    if (parts.length == 3) return hostname;
    else if (parts.length == 4) return parts.slice(1).join('.');
  }

  // eg: sub1.example.com -> example.com
  //     example.com -> example.com
  if (parts.length == 3) return parts.slice(1).join('.');
  else return hostname;
}
